
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CountryRepository from '@/repositories/CountryRepository';

@Component({
    name: 'ClientAddressForm',
})
export default class test extends Vue {
    @Prop({ default: null }) private value!: any;
    @Prop({ required: true }) private addressType!: string;

    private selectedCountry = '';

    private get addressForm() {
        switch (this.addressType) {
            case 'delivery':
                return 'deliveryAddressForm';
            case 'invoice':
                return 'invoiceAddressForm';
            default:
                return 'addressForm';
        }
    }

    private get flagUrl() {
        return `url(https://flagsapi.com/${this.selectedCountry.split('|')[1]}/flat/32.png)` ?? '';
    }

    private get countries() {
        return CountryRepository.getAll();
    }

    private onSelectedCountryChange() {
        const countryId = this.selectedCountry.split('|')[0];

        switch (this.addressType) {
            case 'delivery':
                this.value.deliveryAddressForm.country = countryId;
                break;
            case 'invoice':
                this.value.invoiceAddressForm.country = countryId;
                break;
            default:
                this.value.addressForm.country = countryId;
        }
    }

    private async mounted() {
        await this.$nextTick();

        // Get default country from user group if no country is set or selected one if edit client view
        const countryId = this.value?.addressForm?.country;

        if (countryId) {
            const country = CountryRepository.getById(countryId);
            if (country) {
                this.selectedCountry = country.id + '|' + country.code;
            }
        }
    }
}
